import React from "react"
import CurrentBalanceHeader from "./CurrentBalanceHeader"
import ForecastBanner from "./ForecastBanner"

const CalendarControls = ({
    currentMonth,
    formatDate,
    handleBalancePress,
    user,
    subscriptionStatus,
    findMinimumProjectedBalance,
    handleForecastDatePress,
}) => {
    return (
        <>
            {/* Balance Header Component */}
            <CurrentBalanceHeader
                onBalancePress={user ? handleBalancePress : null}
                type='calendar'
                pageDate={null}
                isPreview={!user}
            />
            {/* Forecast banner with placeholder data for unauthenticated users */}
            <ForecastBanner
    findMinimumProjectedBalance={findMinimumProjectedBalance}
    onForecastDatePress={user ? handleForecastDatePress : null}
    isPreview={!user}
/>
        </>
    )
}

export default CalendarControls